// Мягкое «мяу» синтезируется через Web Audio API — без аудио-ассетов.
// Звук по умолчанию ВЫКЛЮЧЕН, управляется флагом catSound в localStorage.

export function isCatSoundOn() {
  return localStorage.getItem('catSound') === 'true';
}

export function setCatSound(on) {
  localStorage.setItem('catSound', String(on));
}

export function playMeow() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;

    const osc = ctx.createOscillator();
    const filter = ctx.createBiquadFilter();
    const gain = ctx.createGain();

    osc.type = 'sawtooth';
    filter.type = 'lowpass';
    filter.frequency.value = 1400;
    filter.Q.value = 6;

    // «мя-а-у»: быстрый подъём тона, затем плавный спад
    osc.frequency.setValueAtTime(560, now);
    osc.frequency.exponentialRampToValueAtTime(880, now + 0.10);
    osc.frequency.exponentialRampToValueAtTime(430, now + 0.42);

    // Мягкая огибающая громкости
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.16, now + 0.06);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.5);

    osc.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now + 0.55);
    osc.onended = () => ctx.close();
  } catch (e) {
    /* звук необязателен — молча игнорируем */
  }
}

// Довольное двойное «мур-мяу!» — на радостную реакцию (готовое КП, success-тост)
export function playHappyChirp() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();

    const chirp = (start, freqFrom, freqTo, peakGain) => {
      const osc = ctx.createOscillator();
      const filter = ctx.createBiquadFilter();
      const gain = ctx.createGain();

      osc.type = 'triangle';
      filter.type = 'lowpass';
      filter.frequency.value = 2200;
      filter.Q.value = 4;

      osc.frequency.setValueAtTime(freqFrom, start);
      osc.frequency.exponentialRampToValueAtTime(freqTo, start + 0.11);

      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(peakGain, start + 0.04);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.2);

      osc.connect(filter);
      filter.connect(gain);
      gain.connect(ctx.destination);

      osc.start(start);
      osc.stop(start + 0.22);
      return osc;
    };

    const now = ctx.currentTime;
    chirp(now, 700, 1050, 0.14);
    const last = chirp(now + 0.14, 780, 1180, 0.16);
    last.onended = () => ctx.close();
  } catch (e) {
    /* звук необязателен — молча игнорируем */
  }
}

// Тихий грустный скулёж — на реакцию-ошибку (сбой в расчёте, error-тост)
export function playSadWhimper() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;

    const osc = ctx.createOscillator();
    const filter = ctx.createBiquadFilter();
    const gain = ctx.createGain();

    osc.type = 'sine';
    filter.type = 'lowpass';
    filter.frequency.value = 900;
    filter.Q.value = 2;

    // Плавный спад тона вниз — грустная интонация
    osc.frequency.setValueAtTime(520, now);
    osc.frequency.exponentialRampToValueAtTime(340, now + 0.35);
    osc.frequency.exponentialRampToValueAtTime(260, now + 0.7);

    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.08);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.75);

    osc.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now + 0.8);
    osc.onended = () => ctx.close();
  } catch (e) {
    /* звук необязателен — молча игнорируем */
  }
}
